var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suitComponent",class:{ noColor: _vm.noColor }},[_c('fa',{class:_vm.suit,attrs:{"icon":_vm.icon,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }